import React from "react";
import { Stack, Skeleton} from '@chakra-ui/react';

export class LoadingBlock extends React.Component {
    render() {
        return (
            <Stack w="fill">
                <Skeleton height='100px' speed={1.2} />
                <Skeleton height='100px' speed={1.2} />
                <Skeleton height='100px' speed={1.2} />
            </Stack>
        );
    }
}
